jQuery(document).ready( function($) {

	// Google Tag Events
	// data-ga-event="Action/Category/Label/Value"

	$('[data-ga-event]').on('click', function() {
		
		var values = $(this).attr('data-ga-event').split('/');
		var action = values[0];
		var category = values[1];
		var label = values[2];
		var value = typeof values[3] != 'undefined' ? values[3] : false;
		
		gtag(
			'event', 
			action, 
			{
				'event_category': category,
				'event_label': label,
				'value': value
			}
		);
				
	} );
	
} );